import { Book } from '../types'
import { COVERS, FILES, toThumb } from './links'

export const books: Book[] = [
  {
    number: 1,
    title: "Structures & Bridges",
    subtitle: "Paper, straws and the shapes that carry a load",
    accent: '#E8A93A',
    cover: COVERS[1] || toThumb(FILES.books[1] ?? ''),
    projectCount: 36,
    pages: 110,
    file: FILES.books[1] ?? '',
  },
  {
    number: 2,
    title: "Cardboard Robots",
    subtitle: "Walkers, grippers and machines with a face",
    accent: '#2FA8A8',
    cover: COVERS[2] || toThumb(FILES.books[2] ?? ''),
    projectCount: 30,
    pages: 92,
    file: FILES.books[2] ?? '',
  },
  {
    number: 3,
    title: "Cars, Wheels & Racers",
    subtitle: "Axles, friction and everything that rolls",
    accent: '#E2603F',
    cover: COVERS[3] || toThumb(FILES.books[3] ?? ''),
    projectCount: 30,
    pages: 92,
    file: FILES.books[3] ?? '',
  },
  {
    number: 4,
    title: "Catapults & Flight",
    subtitle: "Stored energy, arcs and things that leave the table",
    accent: '#4FA85B',
    cover: COVERS[4] || toThumb(FILES.books[4] ?? ''),
    projectCount: 30,
    pages: 92,
    file: FILES.books[4] ?? '',
  },
  {
    number: 5,
    title: "Machines That Move",
    subtitle: "Gears, cams, pulleys and cranks",
    accent: '#4A9FE0',
    cover: COVERS[5] || toThumb(FILES.books[5] ?? ''),
    projectCount: 30,
    pages: 92,
    file: FILES.books[5] ?? '',
  },
  {
    number: 6,
    title: "Water & Air",
    subtitle: "Boats, pumps, fountains and clouds",
    accent: '#F08A2E',
    cover: COVERS[6] || toThumb(FILES.books[6] ?? ''),
    projectCount: 30,
    pages: 92,
    file: FILES.books[6] ?? '',
  },
  {
    number: 7,
    title: "Grabbers & Claws",
    subtitle: "Machines that reach out and hold on",
    accent: '#93C13C',
    cover: COVERS[7] || toThumb(FILES.books[7] ?? ''),
    projectCount: 30,
    pages: 92,
    file: FILES.books[7] ?? '',
  },
  {
    number: 8,
    title: "Chain Reactions",
    subtitle: "Ramps, triggers and one thing setting off the next",
    accent: '#2FB08A',
    cover: COVERS[8] || toThumb(FILES.books[8] ?? ''),
    projectCount: 30,
    pages: 92,
    file: FILES.books[8] ?? '',
  },
  {
    number: 9,
    title: "Sound & Light",
    subtitle: "Vibration, echo, shadow and colour",
    accent: '#D94F45',
    cover: COVERS[9] || toThumb(FILES.books[9] ?? ''),
    projectCount: 30,
    pages: 92,
    file: FILES.books[9] ?? '',
  },
  {
    number: 10,
    title: "Giant Towers",
    subtitle: "Height, balance, bracing and collapse",
    accent: '#3D7FD1',
    cover: COVERS[10] || toThumb(FILES.books[10] ?? ''),
    projectCount: 30,
    pages: 92,
    file: FILES.books[10] ?? '',
  },
  {
    number: 11,
    title: "Things That Fly",
    subtitle: "Wings, spin, drag and trim",
    accent: '#7A9B3A',
    cover: COVERS[11] || toThumb(FILES.books[11] ?? ''),
    projectCount: 30,
    pages: 92,
    file: FILES.books[11] ?? '',
  },
  {
    number: 12,
    title: "Inventor's Challenges",
    subtitle: "Thirty open briefs with real constraints",
    accent: '#C87A2E',
    cover: COVERS[12] || toThumb(FILES.books[12] ?? ''),
    projectCount: 30,
    pages: 92,
    file: FILES.books[12] ?? '',
  },
]

export const booksByNumber: Record<number, Book> = books.reduce(
  (acc, book) => {
    acc[book.number] = book
    return acc
  },
  {} as Record<number, Book>,
)

export const TOTAL_PROJECTS = books.reduce((n, b) => n + b.projectCount, 0)
export const TOTAL_PAGES = books.reduce((n, b) => n + b.pages, 0)
